import React, { useState, useEffect, useContext } from "react";
import { ImSpinner2 } from "react-icons/im";
// import "../../../Styles/Home.css";
import useTailoring from "../../../hooks/useTailoring";
import TailoringContext from "../../../context/TailoringContext";
import styles from "./TrendStyles.module.css";
import { useNavigate } from "react-router-dom";

const TrendingStyles = ({ paragraph }) => {
  const [trending, setTrending] = useState([]);

  const navigate = useNavigate();

  const { loader } = useContext(TailoringContext);
  const { handleGetTrendingStyle } = useTailoring();

  useEffect(() => {
    handleGetTrendingStyle().then((res) => {
      setTrending(res?.data?.trending);
    });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className={styles.trend}>
        <div className="mb-5">
          <div className="d-flex w-100 justify-content-between text-center">
            <p className={styles.title}>{paragraph}</p>
            <p
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/tailoring/femalestyle")}
            >
              View More
            </p>
          </div>
        </div>
        <div className={styles.trendContent}>
          {loader ? (
            <div className="w-100 text-center">
              <ImSpinner2 size={40} className="spin" />
            </div>
          ) : (
            <div className={styles.trendContent} style={{ cursor: "pointer" }}>
              {trending?.map((item) => (
                <div
                  className=""
                  onClick={() => {
                    navigate("/tailoring/product", {
                      state: {
                        src: item.image_url,
                        id: 2,
                        stylename: item.name,
                        price: item.price,
                        uniqueId: item._id,
                        description: item.desc,
                        style_quantity: item.style_quantity,
                        category: item.category,
                      },
                    });
                  }}
                >
                  <img
                    alt="img"
                    src={item.image_url[0]}
                    className={styles.trendImage}
                  />
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="text-capitalize">{item.name}</div>
                    <p className={styles.trendDesc}>₦{item.price}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="view_btn">
          <p
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/tailoring/femalestyle")}
          >
            View More
          </p>
        </div>
      </div>
    </>
  );
};

export default TrendingStyles;
